var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 211.6 211.6",
    style: {
      enableBackground: "new 0 0 211.6 211.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#fff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.9,27.7C163.1,9.8,139.3,0,114,0c-4.1,0-7.5,3.4-7.5,7.5s3.4,7.5,7.5,7.5c21.3,0,41.3,8.3,56.3,23.3 c15,15,23.3,35,23.3,56.3c0,4.1,3.4,7.5,7.5,7.5c4.1,0,7.5-3.4,7.5-7.5C208.7,69.4,198.8,45.6,180.9,27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.1,94.7c0,4.1,3.4,7.5,7.5,7.5c4.1,0,7.5-3.4,7.5-7.5c0-28.2-22.9-51.1-51.1-51.1c0,0,0,0,0,0 c-4.1,0-7.5,3.4-7.5,7.5c0,4.1,3.4,7.5,7.5,7.5C133.9,58.6,150.1,74.8,150.1,94.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.5,132.9c-11.4-0.6-17.3,7.9-20,12c-2.3,3.4-1.5,8.1,2,10.4s8.1,1.5,10.4-2c3.3-4.8,4.8-5.6,6.8-5.5 c6.5,0.8,32.1,19.5,34.6,25.4c0.6,1.7,0.6,3.4-0.1,5.5c-2.7,8-7.1,13.6-12.9,16.2c-5.4,2.5-12.1,2.3-19.3-0.7 c-26.8-10.9-50.2-26.1-69.5-45.3c0,0,0,0,0,0c-19.1-19.3-34.3-42.7-45.2-69.4c-2.9-7.2-3.1-13.8-0.7-19.3 c2.6-5.7,8.2-10.2,16.2-12.8c2.1-0.7,3.8-0.7,5.5-0.1c5.9,2.6,24.6,28.1,25.4,34.6c0.1,2.1-0.7,3.6-5.5,6.9c-3.4,2.3-4.3,7-2,10.4 c2.3,3.4,7,4.3,10.4,2c4.1-2.8,12.6-8.6,12-20.1c-0.7-12-24-43.7-35.1-47.8c-5-1.8-10.2-1.9-15.5-0.1c-12,4-20.6,11.2-25,20.8 C1.8,63.3,1.9,74,6.4,85.2c11.7,28.6,28,53.6,48.5,74.4c0,0.1,0.1,0.1,0.2,0.1c20.7,20.5,45.8,36.8,74.3,48.4 c5.7,2.3,11.4,3.5,16.7,3.5c5.1,0,9.9-1,14.4-3.1c9.6-4.4,16.8-13,20.8-25c1.8-5.3,1.8-10.5-0.1-15.5 C177.2,156.9,145.5,133.5,133.5,132.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.be6e7337c2c9569488d55c0e2b126c6d.svg";
export { ForwardRef as ReactComponent };